import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./products-card-big.module.scss";
import close from "../../../../images/close.svg";
import chevron from "../../../../images/chevron-left.svg";
import CompanyCard from "../../companies/companies-card/companies-card";
import { Company } from "../../../../services/reducers/companies";
import { removeIndustrialCity } from "../../../../utils/helpers-for-cities";
import CustomScrollbar from "../../../ui-kit/scrollbar/scrollbar";
import { CompaniesByCity } from "../../../../services/reducers/products";

interface Props {
  closeLeftPanel?: (closeLeftPanel: boolean) => void;
  data: CompaniesByCity[];
  name: string;
}

const ProductsCardBig = ({ closeLeftPanel, name, data }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [openedItem, setOpenedItem] = useState<string[]>([]);

  const handleToggleVisibility = () => {
    if (closeLeftPanel) {
      closeLeftPanel(false);
    }
  };

  const handleClose = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("productName");
    setSearchParams(params);
  };

  useEffect(() => {
    setOpenedItem([])
  }, [searchParams.get("productName")])

  useEffect(() => {
    const tidParam = searchParams.get("tid") || "";
    const tidValues = tidParam.split(",").map(item => item.trim()).filter(item => item !== "");
    if (tidValues.length > 0) {
      tidValues.forEach((tid) => {
        const foundCities = data
            .filter(city => city.companies.some((t: Company) => String(t.tenant_id) === tid))
            .map(city => city.cityEn);
        if (foundCities.length > 0) {
          setOpenedItem(prev => Array.from(new Set([...prev, ...foundCities])));
        }
      });
    }
  }, [searchParams, data]);

  const { t, i18n } = useTranslation();

  return (
    <div className={styles.productsCardBig}>
      <div className={styles.header}>
        <h2>{name}</h2>
        <button className={styles.closeButton} onClick={handleClose}>
          <img src={close} alt={t("productsCardBig.closeAlt")} />
        </button>
      </div>
      <CustomScrollbar height={"95%"} marginLeft={"4px"}>
      {data.map((city) => {
        if (city.companies.length === 0) return null;
        const { cleanedName, prefix, suffix } = removeIndustrialCity(
          i18n.language === "ar" ? city.cityAr : city.cityEn,
          i18n.language,
        );
        return (
          <div className={styles.cityCard} key={city.cityEn}>
            <span
              className={`${styles.cityName} ${openedItem?.includes(city.cityEn) ? styles.opened : styles.closed}`}
              onClick={() =>
                openedItem?.includes(city.cityEn)
                  ? setOpenedItem(prev => prev.filter(item => item != city.cityEn))
                  : setOpenedItem(prev => [...prev, city.cityEn])
              }
            >
              {prefix && <span>{prefix}</span>}
              {cleanedName}
              {suffix && <span>{suffix}</span>}
              <img
                src={chevron}
                alt={t("productsCardBig.toggleAlt")}
                className={`${styles.chevron} ${openedItem?.includes(city.cityEn) ? styles.opened : styles.closed}`}
              />
            </span>
            <div className={openedItem?.includes(city.cityEn) ? styles.opened : styles.closed}>
              {city.companies.map((tenant: Company) => {
                const url = new URL(window.location.href);

                url.pathname = url.pathname.replace("products", "companies");
            
                url.searchParams.delete("productName");
            
                url.searchParams.set("tid", String(tenant.tenant_id));
                url.searchParams.set("q",tenant.name_en);
                return (
                  <CompanyCard
                    className={styles.tenantCard}
                    key={tenant.tenant_id}
                    tenant={tenant}
                    qrHref={url.toString()}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
      </CustomScrollbar>
      <div className={styles.dropdown}></div>
      {closeLeftPanel && (
        <button className={styles.toggleButton} onClick={handleToggleVisibility}>
          <img src={chevron} alt={t("productsCardBig.togglePanelAlt")} />
        </button>
      )}
    </div>
  );
};

export default ProductsCardBig;
